import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { X, Trophy, MapPin, Image as ImageIcon, Calendar, Clock, AlignLeft } from 'lucide-react';
import './CreateTournamentModal.css';

export default function CreateTournamentModal({ onClose, onCreate }) {
    const [formData, setFormData] = useState({
        name: '',
        date: '',
        time: '',
        description: '',
        locationUrl: '',
        imageUrl: '',
        isUnranked: false
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.name.trim()) {
            alert('El nombre del torneo es obligatorio.');
            return;
        }
        onCreate(formData);
    };

    return ReactDOM.createPortal(
        <div className="modal-overlay">
            <div className="modal-content glass-panel">
                
                {/* Header */}
                <div className="modal-header">
                    <Trophy className="modal-header-bg-icon" />
                    <div className="modal-header-content">
                        <h2 className="modal-title">
                            <Trophy style={{color: 'var(--accent-yellow)', width:'2rem', height:'2rem'}} />
                            Nuevo Estadio
                        </h2>
                        <p className="modal-subtitle">Configuración del Torneo</p>
                    </div>
                    <button onClick={onClose} className="modal-close-btn">
                        <X className="w-6 h-6" />
                    </button>
                </div>

                {/* Form Body */}
                <form onSubmit={handleSubmit} className="modal-body">
                    {/* Fila 1: Nombre y Tipo */}
                    <div className="form-grid-3">
                        <div className="form-group col-span-2">
                            <label className="form-label">Nombre del Torneo *</label>
                            <input 
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Ej: Torneo Regional Alicante"
                                className="modal-input"
                                required
                            />
                        </div>
                        <div className="form-group" style={{justifyContent: 'flex-end'}}>
                            <label className="checkbox-container">
                                <input 
                                    type="checkbox"
                                    name="isUnranked"
                                    checked={formData.isUnranked}
                                    onChange={handleChange}
                                />
                                <span className="checkbox-label-text">
                                    No Rankeado
                                </span>
                            </label>
                        </div>
                    </div>

                    {/* Fila 2: Fecha y Hora */}
                    <div className="form-grid-2">
                        <div className="form-group">
                            <label className="form-label">
                                <Calendar className="w-4 h-4" /> Fecha
                            </label>
                            <input 
                                type="date"
                                name="date"
                                value={formData.date}
                                onChange={handleChange}
                                className="modal-input"
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">
                                <Clock className="w-4 h-4" /> Hora
                            </label>
                            <input 
                                type="time"
                                name="time"
                                value={formData.time}
                                onChange={handleChange}
                                className="modal-input"
                            />
                        </div>
                    </div>

                    {/* Fila 3: Descripción */}
                    <div className="form-group">
                        <label className="form-label">
                            <AlignLeft className="w-4 h-4" /> Descripción Breve
                        </label>
                        <textarea 
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="2"
                            placeholder="Información extra, reglas específicas, precio de entrada..."
                            className="modal-input modal-textarea"
                        ></textarea>
                    </div>

                    {/* Fila 4: Enlaces */}
                    <div className="modal-section-separator">
                        <div className="form-group">
                            <label className="form-label">
                                <MapPin className="w-4 h-4" /> Ubicación (Google Maps URL)
                            </label>
                            <input 
                                type="url"
                                name="locationUrl"
                                value={formData.locationUrl}
                                onChange={handleChange}
                                placeholder="https://maps.google.com/..."
                                className="modal-input"
                                style={{fontSize: '0.875rem'}}
                            />
                        </div>

                        <div className="form-group" style={{marginTop: '0.5rem'}}>
                            <label className="form-label">
                                <ImageIcon className="w-4 h-4" /> Imagen Destacada (URL)
                            </label>
                            <input 
                                type="url"
                                name="imageUrl"
                                value={formData.imageUrl}
                                onChange={handleChange}
                                placeholder="https://ejemplo.com/imagen.jpg"
                                className="modal-input"
                                style={{fontSize: '0.875rem'}}
                            />
                            {formData.imageUrl && (
                                <div className="image-preview-box">
                                    <img src={formData.imageUrl} alt="Preview" onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; }} />
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Actions */}
                    <div className="modal-actions">
                        <button type="button" onClick={onClose} className="btn-modal-cancel">
                            Cancelar
                        </button>
                        <button type="submit" className="btn-modal-submit">
                            <Trophy className="w-5 h-5" /> Iniciar Torneo
                        </button>
                    </div>
                </form>
            </div>
        </div>,
        document.body
    );
}
